import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.tsx";
import { reloadOnceForStaleChunk } from "./lib/lazyLoad.ts";
import { initPwa } from "./lib/pwa.ts";
import "./index.css";

initPwa();

// Vite reports a failed preload of a lazily loaded chunk here (typically a file from before a deploy). Reload once to get
// the new version; if that was just tried, let the error reach the page's ChunkErrorBoundary instead.
window.addEventListener("vite:preloadError", (event) => {
  if (reloadOnceForStaleChunk()) event.preventDefault();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
